var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.58654V6.03708C1 4.62502 1.63214 3.27079 2.75736 2.27231C3.88258 1.27383 5.4087 0.712891 7 0.712891C8.5913 0.712891 10.1174 1.27383 11.2426 2.27231C12.3679 3.27079 13 4.62502 13 6.03708V9.58654",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.1781C13 10.4919 12.8595 10.7928 12.6095 11.0147C12.3594 11.2366 12.0203 11.3612 11.6667 11.3612H11C10.6464 11.3612 10.3072 11.2366 10.0572 11.0147C9.80714 10.7928 9.66667 10.4919 9.66667 10.1781V8.40337C9.66667 8.08958 9.80714 7.78864 10.0572 7.56675C10.3072 7.34487 10.6464 7.22021 11 7.22021H13V10.1781ZM1 10.1781C1 10.4919 1.14048 10.7928 1.39052 11.0147C1.64057 11.2366 1.97971 11.3612 2.33333 11.3612H3C3.35362 11.3612 3.69276 11.2366 3.94281 11.0147C4.19286 10.7928 4.33333 10.4919 4.33333 10.1781V8.40337C4.33333 8.08958 4.19286 7.78864 3.94281 7.56675C3.69276 7.34487 3.35362 7.22021 3 7.22021H1V10.1781Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerService);
export default __webpack_public_path__ + "static/media/icon_customer_service.e9849e0cbd1a3e9ac28cb03f2713f744.svg";
export { ForwardRef as ReactComponent };